var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('v-sheet',_vm._b({attrs:{"rounded":"","color":_vm.color,"height":_vm.height,"width":_vm.width,"icon":_vm.icon}},'v-sheet',_vm.$attrs,false),[_c('p',{class:_vm.textProp},[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n       \n      "+_vm._s(_vm.label)+"\n    ")],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }